var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var Upsert_User_Only_Email_OneDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation upsert_user_only_email_one($Email: String!) {\n  insert_user_one(\n    object: {Email: $Email}\n    on_conflict: {constraint: user_Email_key, update_columns: [Auth0UserId]}\n  ) {\n    id\n  }\n}\n    "], ["\n    mutation upsert_user_only_email_one($Email: String!) {\n  insert_user_one(\n    object: {Email: $Email}\n    on_conflict: {constraint: user_Email_key, update_columns: [Auth0UserId]}\n  ) {\n    id\n  }\n}\n    "])));
/**
 * __useUpsert_User_Only_Email_OneMutation__
 *
 * To run a mutation, you first call `useUpsert_User_Only_Email_OneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsert_User_Only_Email_OneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserOnlyEmailOneMutation, { data, loading, error }] = useUpsert_User_Only_Email_OneMutation({
 *   variables: {
 *      Email: // value for 'Email'
 *   },
 * });
 */
export function useUpsert_User_Only_Email_OneMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(Upsert_User_Only_Email_OneDocument, options);
}
export var Update_New_Lead_With_User_And_LanguageDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation update_new_lead_with_user_and_language($id: uuid!, $userId: uuid!, $language: String!) {\n  update_new_leads(\n    args: {_where: {id: {_eq: $id}}, UserId: $userId, Language: $language}\n  ) {\n    id\n  }\n}\n    "], ["\n    mutation update_new_lead_with_user_and_language($id: uuid!, $userId: uuid!, $language: String!) {\n  update_new_leads(\n    args: {_where: {id: {_eq: $id}}, UserId: $userId, Language: $language}\n  ) {\n    id\n  }\n}\n    "])));
/**
 * __useUpdate_New_Lead_With_User_And_LanguageMutation__
 *
 * To run a mutation, you first call `useUpdate_New_Lead_With_User_And_LanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_New_Lead_With_User_And_LanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewLeadWithUserAndLanguageMutation, { data, loading, error }] = useUpdate_New_Lead_With_User_And_LanguageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdate_New_Lead_With_User_And_LanguageMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(Update_New_Lead_With_User_And_LanguageDocument, options);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVXBzZXJ0VXNlckFuZFVwZGF0ZU5ld0xlYWQuZ3FsLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZVVwc2VydFVzZXJBbmRVcGRhdGVOZXdMZWFkLmdxbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBRUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQ3JDLE9BQU8sS0FBSyxNQUFNLE1BQU0sZ0JBQWdCLENBQUM7QUFDekMsSUFBTSxjQUFjLEdBQUcsRUFBVyxDQUFDO0FBa0JuQyxNQUFNLENBQUMsSUFBTSxrQ0FBa0MsR0FBRyxHQUFHLDZSQUFBLDBOQVNoRCxJQUFBLENBQUM7QUFHTjs7Ozs7Ozs7Ozs7Ozs7OztHQWdCRztBQUNILE1BQU0sVUFBVSxxQ0FBcUMsQ0FBQyxXQUF5SDtJQUN2SyxJQUFNLE9BQU8seUJBQU8sY0FBYyxHQUFLLFdBQVcsQ0FBQyxDQUFBO0lBQ25ELE9BQU8sTUFBTSxDQUFDLFdBQVcsQ0FBa0Ysa0NBQWtDLEVBQUUsT0FBTyxDQUFDLENBQUM7QUFDMUosQ0FBQztBQUlQLE1BQU0sQ0FBQyxJQUFNLDhDQUE4QyxHQUFHLEdBQUcsMFNBQUEsdU9BUTVELElBQUEsQ0FBQztBQUdOOzs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FrQkc7QUFDSCxNQUFNLFVBQVUsaURBQWlELENBQUMsV0FBaUo7SUFDM00sSUFBTSxPQUFPLHlCQUFPLGNBQWMsR0FBSyxXQUFXLENBQUMsQ0FBQTtJQUNuRCxPQUFPLE1BQU0sQ0FBQyxXQUFXLENBQTBHLDhDQUE4QyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQzlMLENBQUMifQ==